import { ProfileUserInfoDto } from '../types/dtos/profile-user-info'
import { ProfileUserInfoModel } from '../types/models/profile-user-info'

export const transformProfileUserInfoDto = (
  response: ProfileUserInfoDto,
): ProfileUserInfoModel => ({
  canSendTemplates: response.can_send_templates,
  showSupportFunctionality: response.show_support_functionality,
  isShadowBanned: response.shadow_banned,
  isPermanentlyBanned: response.permanently_banned,
  isTemporarilyBanned: response.temporarily_banned,
  isCompromised: response.compromised,
  isListingRestricted: response.listing_restricted,
  isSellingRestricted: response.selling_restricted,
})
